import { getCommitStatus } from "AppSrc/project/commits/row";
import { ApproveRejectForm } from "AppSrc/project/commits/approveReject";
import { Tooltip } from "react-tippy";
import React from "react";
import { BSBtn } from "traec-react/utils/bootstrap";

import { getChildMetricScores, isAllRequiredSubmitted } from "storybook-dashboard/utils";

import { rpName } from "storybook-dashboard/dashboard/project/reportStatus";
import Octicon from "react-octicon";
import Im from "immutable";
import { useReportContext } from "storybook-dashboard/context/report";

export const Submit = (props) => {
  let { commit, isResponsible, inputValueMap, nodes, nodesByPath, getChildren, rootNode, getChildDocumentsWithStatus } = useReportContext();

  let {
    currentReportingPeriod,
    disableInputs,
    inputErrors,
    postCommit,
    patchCommit,
    needsRevision,
    categoryTrees,
    revalidate,
  } = props;

  let commitStatus = getCommitStatus(commit);

  // Get if all of the sections are complete
  if (commitStatus && commitStatus.startsWith("Not for")) {
    return <BSBtn text="Reporting On Hold" onClick={null} disabled={true} />;
  }

  if (!commit.get("is_staging") && !(commitStatus === "Requires Revision")) {
    let currentPeriodString = currentReportingPeriod ? rpName(currentReportingPeriod) : "";
    return <ApproveRejectForm {...{ currentPeriodString }} />;
  }

  if (disableInputs) {
    return null;
  }

  let _docStatus = getChildDocumentsWithStatus(
    rootNode?.get("_path"),
    currentReportingPeriod,
  );

  let hasAllRequired = isAllRequiredSubmitted(
    inputValueMap,
    getChildMetricScores("", nodesByPath, inputValueMap.toList(), currentReportingPeriod),
    nodes,
    currentReportingPeriod,
    _docStatus,
  );
  let sectionsWithErrors = (inputErrors || Im.Map()).toList().filter((i) => i.size);

  if (hasAllRequired !== true || sectionsWithErrors.size) {
    console.log(
      "Blocking submit",
      Im.isImmutable(hasAllRequired) ? hasAllRequired.toJS() : null,
      sectionsWithErrors.size,
    );
    let errorText = getErrorText(hasAllRequired, inputErrors, categoryTrees);
    return (
      <div className={"float-right"}>
        <Tooltip html={<div className={"text-left"}>{errorText}</div>} animateFill={false}>
          <BSBtn text="Submit report" disabled={true} noFloatRight={true} />
        </Tooltip>
        <Tooltip html={"Re-validate this form"} animateFill={false}>
          <Octicon
            name="sync"
            className="text-secondary ml-3"
            style={{ cursor: "pointer" }}
            onClick={(e) => revalidate()}
          />
        </Tooltip>
      </div>
    );
  }
  return (
    <SubmitButton
      commit={commit}
      postCommit={postCommit}
      patchCommit={patchCommit}
      needsRevision={needsRevision}
      isResponsible={isResponsible()}
    />
  );
};

export const SubmitButton = ({ postCommit, patchCommit, isResponsible, commit, needsRevision }) => {
  let method = needsRevision({ isResponsible, commit }) ? patchCommit : postCommit;
  return <BSBtn text="Submit report" onClick={method} />;
};

const getErrorText = (required, inputErrors) => {
  // Get a mapping from issue paths to real names
  let _inputErrors = inputErrors
    ? inputErrors
        .valueSeq()
        .filter((i) => Im.isImmutable(i) && i.get("name"))
        .map((item, i) => <div key={i}>{`${item.get("name")} was given a non-number value: ${item.get("value")}`}</div>)
    : Im.List();

  let _tooltip = _inputErrors.size ? (
    <React.Fragment>
      {sectionErrors}
      {_inputErrors}
    </React.Fragment>
  ) : (
    <React.Fragment>
      <li>Please enter required data before submitting the report</li>
      {required.map((item, i) => (
        <ul key={i}>{item.getIn(["metric", "name"])}</ul>
      ))}
    </React.Fragment>
  );

  return <ul className="tooltip-list">{_tooltip}</ul>;
};
